import { make } from 'vuex-pathify'
import dottie from 'dottie'
import { api } from '@/api'
import axios from 'axios'

const state = {
  reward: null, // ie: 5eaae6e3c39e8e03f4f89adc
  product: null, // ie: 5f665774e1fe2dcb2dcc5a95
  profile: null,
  nickname: null,
  urlAlias: null,
  userId: null,
  fbId: '1006445999864807',
  active: false,
  subscription: null
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  read(
    state,
    {
      reward,
      product,
      rewards,
      products,
      profile,
      nickname,
      urlAlias,
      userId,
      fbId,
      recommendations,
      unlockables
    }
  ) {
    state.reward = reward
    state.product = product
    state.rewards = rewards
    state.products = products
    state.profile = profile
    state.nickname = nickname
    state.urlAlias = urlAlias
    state.userId = userId
    state.fbId = fbId
    state.recommendations = recommendations
    state.unlockables = unlockables
    state.readOK = true
  },

  readFailed(state) {
    state.reward = null
    state.product = null
    state.rewards = []
    state.products = []
    state.profile = null
    state.nickname = null
    state.urlAlias = null
    state.userId = null
    state.fbId = '1006445999864807'
    state.recommendations = null
    state.unlockables = null
    state.readOK = false
  },

  foundActiveSubscription(state, { active, subscription }) {
    state.active = active
    state.subscription = subscription
  }
}

const setupVideoSources = async (item) => {
  if (!item || !item.media) return item
  for (const m of item.media) {
    if (m.mimeType === 'application/x-mpegurl') {
      const masterPlaylistUrl = `/uploads/public/${item.user}/${m.name}/master.m3u8`
      try {
        const response = await axios.get(masterPlaylistUrl)
        if (response && response.status === 200) {
          m.sources = [
            {
              src: masterPlaylistUrl,
              type: 'application/x-mpegurl'
            }
          ]
        }
      } catch (_) {}
    }
  }

  return item
}

const actions = {
  async read({ commit }, { rewardId, buyerId }) {
    let userId

    try {
      const response = await api.get(`/rewards/${rewardId}`)

      const itemData = response.data.item
      if (itemData && !itemData.user) {
        itemData.user = response.data._id
      }
      const item = await setupVideoSources(itemData)

      const reward = item.type === 'reward' ? item : null
      const product = item.type === 'product' ? item : null

      const rewards = dottie
        .get(response, 'data.rewards', [])
        .map((p) => ({ ...p, itemType: 'reward' }))
      const products = dottie
        .get(response, 'data.products', [])
        .map((p) => ({ ...p, itemType: 'product' }))

      const profile = dottie.get(response, 'data.profile', null)
      const nickname = dottie.get(response, 'data.nickname', null)
      const urlAlias = dottie.get(response, 'data.urlAlias', null)
      const fbId = dottie.get(response, 'data.fbId', '1006445999864807')
      userId = dottie.get(response, 'data._id', null)
      const recs = dottie.get(response, 'data.recommendations', null)
      const recommendations = [
        ...(recs.rewards || []).map((r) => {
          r.itemType = 'reward'
          return r
        }),
        ...(recs.products || []).map((p) => {
          p.itemType = 'product'
          return p
        })
      ]

      const unlocks = dottie.get(response, 'data.unlockables', null)
      const unlockables = [
        ...(unlocks.rewards || []).map((r) => {
          r.itemType = 'reward'
          return r
        }),
        ...(unlocks.products || []).map((p) => {
          p.itemType = 'product'
          return p
        })
      ]

      commit('read', {
        reward,
        product,
        rewards,
        products,
        profile,
        nickname,
        urlAlias,
        userId,
        fbId,
        recommendations,
        unlockables
      })
    } catch (e) {
      commit('readFailed')
    }

    if (userId && buyerId) {
      try {
        const response = await api.get(
          `/pledges/${userId}/${buyerId}/${rewardId}`
        )
        const active = dottie.get(response, 'data.active', null)
        const subscription = dottie.get(response, 'data.subscription', null)

        commit('foundActiveSubscription', { active, subscription })
      } catch (error) {}
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
